<template>
  <div id="preliminary">
    <el-row>
      <el-col :span="12">
        <h3>Select a tournament</h3>
        <el-select
          placeholder="Select"
          value
          @change="selectTournament"
          v-model="tournamentIdentifier"
        >
          <el-option
            v-for="item in tournaments"
            :key="item.tournamentId"
            :label="item.name"
            :value="item.tournamentId"
          >
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              moment(item.startDate).format("MMM DD")
            }}</span>
          </el-option>
        </el-select>
        <el-button @click="tournamentIdentifier = ''">Clear</el-button>
      </el-col>
    </el-row>

    <div
      v-if="!entries || !entries.edition"
      class="result-area"
      :key="componentKey"
    >
      <p>
        No data to display currently. Either you have not selected a tournament
        or the tournament you have selected has no preliminary list yet.
      </p>
    </div>

    <div v-if="entries && entries.edition" :key="componentKey">
      <table style="width: 100%" class="result-area">
        <tr>
          <td>Tournament Name: {{ entries.edition.name }}</td>
          <td>
            Tournament Level: {{ tourLevelFormatter(entries.edition.level) }}
          </td>
        </tr>
        <tr>
          <td>Surface: {{ entries.edition.surface }}</td>
          <td>Prize Money: {{ entries.edition.prizeMoney | toCurrency }}</td>
        </tr>
        <tr>
          <td>
            Week of Year: {{ moment(entries.edition.startDate).week() }}, Start:
            {{ moment(entries.edition.startDate).format("DD MMM YYYY") }}
          </td>
          <td>Draw Size: {{ entries.edition.double.main.size }}</td>
        </tr>
        <tr>
          <td>Doubles Entry Deadline: {{ moment(entries.edition.double.main.entryDeadline).format("DD MMM YYYY") }}</td>
          <td>Direct In: {{ entries.edition.double.main.numberOfDirects }}</td>
        </tr>
        <tr>
          <td>Byes: {{ entries.edition.double.main.numberOfByes }}</td>
          <td>Wildcards: {{ entries.edition.double.main.numberOfWildcards  }}</td>
        </tr>
        <!-- <tr>
          <td>On-site: {{ entries.edition.double.main.exemptions.entries}}</td>
        </tr> -->
      </table>

      <h3 style="padding-top: 20px">
        Preliminary List for {{ entries.edition.name }}
      </h3>
      <div class="result-area">
        This preliminary list shows all players who entered the selected
        tournament to date. Entries are sorted by current ranking. Please note
        the preliminary list is NOT a final Acceptance List.
      </div>
      <el-table
        style="width: 100%"
        :border="true"
        :data="entries.alternates"
        class="entries"
      >
        <el-table-column label="Pos" type="index" width="60"></el-table-column>
        <el-table-column label="Combined Rank" width="120">
          <template slot-scope="scope">{{ scope.row.rank }}</template>
        </el-table-column>
        <el-table-column label="Player" width="400">
          <template slot-scope="scope"
            >{{ scope.row.player.lastName }}, {{ scope.row.player.firstName }}
            {{
              suppressBlrRusNationality(scope.row.player.nationality)
            }}</template
          >
        </el-table-column>
        <el-table-column label="Player Ranking" width="120">
          <template slot-scope="scope">
            {{ scope.row.effectivePlayerRank }}
            {{ scope.row.playerUsesSpecialRank ? "SR" : "" }}
          </template>
        </el-table-column>
        <el-table-column label="Partner" width="400">
          <template slot-scope="scope"
            >{{ scope.row.partner.lastName }},
            {{ scope.row.partner.firstName }}
            {{
              suppressBlrRusNationality(scope.row.partner.nationality)
            }}</template
          >
        </el-table-column>
        <el-table-column label="Partner Ranking" width="120">
          <template slot-scope="scope">
            {{ scope.row.effectivePartnerRank }}
            {{ scope.row.partnerUsesSpecialRank ? "SR" : "" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      tournamentIdentifier: "",
      componentKey: 0,
    };
  },
  mounted() {
    this.fetchTournamentsForPrelimListDoubles();
  },
  computed: {
    ...mapGetters("singlesEntrySystem", [
      "prelimEntriesDoubles",
      "tournamentsForPrelimListDoubles",
    ]),
    entries() {
        this.componentKey; // very dirty hack to have this re-evaluated by trigger
        if (this.tournamentIdentifier !== "") {
          // console.log(this.prelimEntriesDoubles[this.tournamentIdentifier]);
          if (
            this.prelimEntriesDoubles[this.tournamentIdentifier] &&
            this.prelimEntriesDoubles[this.tournamentIdentifier].Type
          ) {
            return [];
          }
          return this.prelimEntriesDoubles[this.tournamentIdentifier];
        } else {
          return this.prelimEntriesDoubles[
            this.tournamentIdentifierQualification
          ];
        }
      },
    tournaments() {
        let result = [];
        this.tournamentsForPrelimListDoubles.forEach((element) => {
          let alGenerationDate = moment.utc(
            element.withdrawDDate.replace("00:00:00", "22:00:00")
          );
          if (alGenerationDate > moment.utc()) {
            result.push(element);
          }
        });
        return result;
      },
  },
  methods: {
    ...mapActions("singlesEntrySystem", ["fetchPreliminaryListDoubles", 'fetchTournamentsForPrelimListDoubles']),
    selectTournament(tournamentIdentifier) {
      this.tournamentIdentifierQualification = "";
      let loader = Loading.service({
        target: "#selection-tabs",
        fullscreen: false,
      });
      let that = this;
      this.fetchPreliminaryListDoubles([tournamentIdentifier, "M"])
        .then(() => {
          that.$nextTick(() => {
            that.componentKey += 1;
            loader.close();
          });
        })
        .catch((error) => {
          that.$nextTick(() => {
            that.componentKey += 1;
            loader.close();
          });
        });
    },
    suppressBlrRusNationality(string) {
      return string === "RUS" || string === "BLR" ? "" : "(" + string + ")";
    },
  },
};
</script>


<style scoped>
.attribute-element {
  display: flex;
  border: 1px solid black;
  align-items: center;
}

.attribute-element .label {
  border-right: 1px solid black;
  padding: 4px;
  min-width: 100px;
  background-color: dimgray;
  color: white;
}

.attribute-element .data {
  width: 100%;
  padding-left: 6px;
  padding-top: 2px;
}

.result-area {
  margin-top: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/DoublesPreliminary.vue